/* ads_pdp_buy_golden (pdp-design-v1) — JS externalised to stay under Shopify's section size limit. Pure JS, no Liquid. */

  (function () {
    class V2SignaturePdp extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.data = JSON.parse(document.getElementById('v2-pdp-data-' + this.dataset.sectionId).textContent);
        this.colorOption = Number(this.dataset.colorOption || 1);
        this.reservationVariantId = Number(this.dataset.reservationVariantId || 0);
        this.reservationSellingPlanId = Number(this.dataset.reservationSellingPlanId || 0);
        this.filterMediaByAlt = this.dataset.filterMediaByAlt === 'true';
        this.soldOutColors = (this.dataset.soldoutColors || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
        this.soldOutLabel = this.dataset.soldoutLabel || 'Udsolgt';
        this.modalImg = this.querySelector('.v2_pdp_modal_img');
        this.variantInput = this.querySelector('.v2_pdp_variant_id');
        this.modal = this.querySelector('dialog.v2_pdp_modal');
        this.giftModal = this.querySelector('dialog.v2_pdp_gift_modal');
        this.selectedVariantId = (this.variantInput && this.variantInput.value)
          || (this.data.variants[0] && this.data.variants[0].id);
        this.initSlider();
        this.initLightbox();
        this.initSwatches();
        this.initReserve();
        this.initReserveCta();
        this.initModal();
        this.initGiftSelectionModal();
        this.initDirectBuy();
        this.initStickyChooseColor();
        this.initStickyColorModal();
        this.initEmailFormCheckout();
        var initialColor = this.querySelector('[data-swatch-group="page"] .v2_pdp_swatch.is-selected[data-color-block]');
        if (initialColor) {
          this.setColorOption(initialColor);
        } else if (this.filterMediaByAlt) {
          var initialVariant = this.querySelector('[data-swatch-group="page"] .v2_pdp_swatch.is-selected[data-variant-selector]');
          if (initialVariant) this.setVariant(initialVariant.dataset.optionValue, 'page');
        }
        var initSel = this.querySelector('[data-swatch-group="page"] .v2_pdp_swatch.is-selected');
        if (initSel) this.applySoldOut(initSel.dataset.optionValue);
      }

      disconnectedCallback() {
        if (this.giftModal && this.giftModal.parentNode === document.body) {
          if (this.giftModal.open && typeof this.giftModal.close === 'function') {
            try { this.giftModal.close(); } catch (err) {}
          }
          this.giftModal.remove();
        }
        if (document.documentElement.dataset.v2GiftScrollLock === '1') {
          delete document.documentElement.dataset.v2GiftScrollLock;
          document.documentElement.style.overflow = '';
          document.body.style.overflow = '';
        }
      }

      findVariant(optionValue) {
        var key = 'option' + this.colorOption;
        return this.data.variants.find(function (v) { return v[key] === optionValue; }) || this.data.variants[0];
      }

      applySoldOut(colorName) {
        if (!this.soldOutColors || !this.soldOutColors.length) { this._soldOut = false; return; }
        var name = String(colorName || '').trim().toLowerCase();
        var isSoldOut = this.soldOutColors.indexOf(name) !== -1;
        this._soldOut = isSoldOut;
        var self = this;
        this.querySelectorAll('.v2_pdp_buy_buttons').forEach(function (buyWrap) {
          buyWrap.classList.toggle('is-color-soldout', isSoldOut);
          var btn = buyWrap.querySelector('button[type="submit"]') || buyWrap.querySelector('.button') || buyWrap.querySelector('button');
          if (!btn) return;
          if (btn._origHTML == null) btn._origHTML = btn.innerHTML;
          if (isSoldOut) {
            btn.innerHTML = '<span class="v2_pdp_soldout_text">' + self.soldOutLabel + '</span>';
            btn.setAttribute('aria-disabled', 'true');
          } else {
            btn.innerHTML = btn._origHTML;
            btn.removeAttribute('aria-disabled');
          }
        });
      }

      altMatchesVariant(alt, optionValue) {
        if (!optionValue) return true;
        var a = String(alt || '').trim().toLowerCase();
        var v = String(optionValue || '').trim().toLowerCase();
        if (!a || !v) return false;
        if (a === v) return true;
        if (a.indexOf(v) !== 0) return false;
        var next = a.charAt(v.length);
        return next === '' || next === ' ' || next === '-';
      }

      filterGalleryByAlt(optionValue) {
        if (!this.filterMediaByAlt) return false;
        var root = this.mediaRoot || this;
        var slides = root.querySelectorAll('.v2_pdp_slide');
        var thumbs = root.querySelectorAll('.v2_pdp_thumb');
        if (!slides.length) return false;

        var matchCount = 0;
        var self = this;
        slides.forEach(function (slide) {
          var alt = slide.dataset.alt || ((slide.querySelector('img') || {}).alt) || '';
          var on = self.altMatchesVariant(alt, optionValue);
          slide.hidden = !on;
          if (on) matchCount += 1;
        });
        thumbs.forEach(function (thumb) {
          var alt = thumb.dataset.alt || thumb.getAttribute('aria-label') || '';
          thumb.hidden = !self.altMatchesVariant(alt, optionValue);
        });

        if (matchCount === 0) {
          slides.forEach(function (slide) { slide.hidden = false; });
          thumbs.forEach(function (thumb) { thumb.hidden = false; });
        }

        this.bindActiveGallery(true);
        return true;
      }

      setVariant(optionValue, source) {
        var variant = this.findVariant(optionValue);
        if (!variant) return;
        var modalOnly = source === 'modal';
        var swatchScope = modalOnly
          ? this.querySelectorAll('.v2_pdp_swatches--modal .v2_pdp_swatch')
          : this.querySelectorAll('[data-swatch-group="page"] .v2_pdp_swatch');
        swatchScope.forEach(function (btn) {
          var on = btn.dataset.optionValue === optionValue;
          btn.classList.toggle('is-selected', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (variant.featured_image && this.modalImg) this.modalImg.src = variant.featured_image;
        this.selectedVariantId = variant.id;
        if (this.variantInput) this.variantInput.value = variant.id;
        this.querySelectorAll('.v2_pdp_buy_buttons input[name="id"], .v2_pdp_buy_buttons .main-product-variant-input').forEach(function (input) {
          input.value = variant.id;
        });
        if (modalOnly) return;
        var selectedLabel = this.querySelector('.v2_pdp_swatch_selected--desktop');
        if (selectedLabel) selectedLabel.textContent = optionValue;
        if (this.filterMediaByAlt) {
          this.filterGalleryByAlt(optionValue);
        } else if (variant.featured_media_id && !this.querySelector('.v2_pdp_color_gallery')) {
          var slide = this.querySelector('.v2_pdp_slide[data-media-id="' + variant.featured_media_id + '"]');
          if (slide) this.goTo(Number(slide.dataset.index));
        }
        this.querySelectorAll('.v2_pdp_price_current').forEach(function (el) {
          if (variant.price) el.textContent = variant.price;
        });
        this.querySelectorAll('.v2_pdp_price_compare').forEach(function (el) {
          if (variant.compare_at_price) {
            el.textContent = variant.compare_at_price;
            el.hidden = false;
          } else {
            el.hidden = true;
          }
        });
        this.applySoldOut(optionValue);
      }

      initSlider() {
        var self = this;
        this.mediaRoot = this.querySelector('.v2_pdp_media');
        this.bindActiveGallery(true);

        if (!this.mediaRoot || this._sliderDelegated) return;
        this._sliderDelegated = true;

        window.addEventListener('resize', function () { self.goTo(self.index, true); });

        this.mediaRoot.addEventListener('click', function (event) {
          var thumb = event.target.closest('.v2_pdp_thumb');
          if (thumb && self.mediaRoot.contains(thumb)) {
            self.goTo(Number(thumb.dataset.index));
            return;
          }
          var prev = event.target.closest('.v2_pdp_thumb_prev, .v2_pdp_slider_prev');
          if (prev && self.mediaRoot.contains(prev)) {
            event.preventDefault();
            self.goTo(self.index - 1);
            return;
          }
          var next = event.target.closest('.v2_pdp_thumb_next, .v2_pdp_slider_next');
          if (next && self.mediaRoot.contains(next)) {
            event.preventDefault();
            self.goTo(self.index + 1);
          }
        });

        var startX = 0;
        var dragging = false;
        this.mediaRoot.addEventListener('pointerdown', function (event) {
          var viewport = event.target.closest('.v2_pdp_slider_viewport');
          if (!viewport || !self.mediaRoot.contains(viewport)) return;
          if (event.target.closest('button, a, video, iframe')) return;
          dragging = true;
          startX = event.clientX;
          try { viewport.setPointerCapture(event.pointerId); } catch (err) {}
        });
        this.mediaRoot.addEventListener('pointerup', function (event) {
          if (!dragging) return;
          dragging = false;
          var delta = event.clientX - startX;
          if (Math.abs(delta) < 40) {
            // A tap (not a swipe) on the image opens the expanded view.
            if (typeof self.openLightbox === 'function') self.openLightbox(self.index);
            return;
          }
          self.goTo(delta < 0 ? self.index + 1 : self.index - 1);
        });
        this.mediaRoot.addEventListener('pointercancel', function () { dragging = false; });
      }

      bindActiveGallery(instant) {
        var gallery = this.querySelector('.v2_pdp_color_gallery:not([hidden])');
        var root = gallery || this.mediaRoot || this;
        this.slider = root.querySelector('[data-slider]');
        this.viewport = root.querySelector('.v2_pdp_slider_viewport');
        this.track = root.querySelector('.v2_pdp_slider_track');
        var allSlides = Array.prototype.slice.call(root.querySelectorAll('.v2_pdp_slide'));
        var allThumbs = Array.prototype.slice.call(root.querySelectorAll('.v2_pdp_thumb'));
        this.slides = allSlides.filter(function (slide) { return !slide.hidden; });
        this.thumbs = allThumbs.filter(function (thumb) { return !thumb.hidden; });
        this.slides.forEach(function (slide, i) { slide.dataset.index = String(i); });
        this.thumbs.forEach(function (thumb, i) { thumb.dataset.index = String(i); });
        this.thumbTrack = root.querySelector('.v2_pdp_thumb_track');
        if (!this.track || !this.slides.length) {
          this.index = 0;
          return;
        }
        var startIndex = 0;
        if (!this.filterMediaByAlt && this.slider) {
          var desired = Number(this.slider.dataset.index || 0);
          var featuredId = null;
          var featuredSlide = root.querySelector('.v2_pdp_slide.is-active:not([hidden])') || this.slides[desired] || this.slides[0];
          if (featuredSlide) featuredId = featuredSlide.dataset.mediaId;
          if (featuredId) {
            var matchIndex = this.slides.findIndex(function (slide) { return slide.dataset.mediaId === featuredId; });
            if (matchIndex >= 0) startIndex = matchIndex;
          }
        }
        this.index = startIndex;

        // Pagination dots — mobile "more images" indicator
        this.dots = [];
        var oldDots = root.querySelectorAll('.v2_pdp_dots');
        for (var di = 0; di < oldDots.length; di++) { oldDots[di].parentNode.removeChild(oldDots[di]); }
        var sliderEl = root.querySelector('.v2_pdp_slider');
        if (sliderEl && sliderEl.parentNode && this.slides.length > 1) {
          var dotsWrap = document.createElement('div');
          dotsWrap.className = 'v2_pdp_dots';
          var selfD = this;
          this.slides.forEach(function (s, i) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'v2_pdp_dot';
            dot.setAttribute('aria-label', 'Vis billede ' + (i + 1));
            dot.addEventListener('click', function () { selfD.goTo(i); });
            dotsWrap.appendChild(dot);
            selfD.dots.push(dot);
          });
          sliderEl.parentNode.insertBefore(dotsWrap, sliderEl.nextSibling);
        }

        this.goTo(this.index, instant !== false);
        this.ensureSliderAligned();
      }

      ensureSliderAligned() {
        var self = this;
        var retries = 0;
        var sync = function () {
          if (!self.viewport || !self.track || !self.slides || !self.slides.length) return;
          if (self.viewport.clientWidth < 10 && retries < 12) {
            retries += 1;
            requestAnimationFrame(sync);
            return;
          }
          self.goTo(self.index, true);
        };
        requestAnimationFrame(sync);
        window.addEventListener('load', function onLoad() {
          window.removeEventListener('load', onLoad);
          self.goTo(self.index, true);
        });
      }

      goTo(index, instant) {
        if (!this.slides || !this.slides.length) return;
        var total = this.slides.length;
        this.index = ((index % total) + total) % total;
        if (this.track) {
          var activeSlide = this.slides[this.index];
          var offset = 0;
          if (activeSlide && this.track) {
            offset = activeSlide.offsetLeft;
            if (!offset && this.index > 0 && this.viewport) {
              offset = this.index * this.viewport.clientWidth;
            }
          } else if (this.viewport) {
            offset = this.index * this.viewport.clientWidth;
          }
          this.track.style.transition = instant ? 'none' : 'transform 0.35s ease';
          this.track.style.transform = 'translate3d(' + (-offset) + 'px, 0, 0)';
          if (instant) {
            // Force reflow so later animated moves still transition.
            void this.track.offsetHeight;
            this.track.style.transition = '';
          }
        }
        this.slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === this.index);
        }.bind(this));
        this.thumbs.forEach(function (thumb, i) {
          thumb.classList.toggle('is-active', i === this.index);
        }.bind(this));
        if (this.dots && this.dots.length) {
          this.dots.forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === this.index);
          }.bind(this));
        }
        this.scrollActiveThumbIntoView(instant);
      }

      scrollActiveThumbIntoView(instant) {
        var track = this.thumbTrack;
        var activeThumb = this.thumbs && this.thumbs[this.index];
        if (!track || !activeThumb) return;

        var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        if (maxScroll <= 0) {
          track.scrollLeft = 0;
          return;
        }

        // Prefer keeping the active thumb fully visible; center when possible.
        var trackRect = track.getBoundingClientRect();
        var thumbRect = activeThumb.getBoundingClientRect();
        var thumbLeft = thumbRect.left - trackRect.left + track.scrollLeft;
        var target = thumbLeft - (track.clientWidth / 2) + (activeThumb.offsetWidth / 2);
        if (this.index === 0) target = 0;
        target = Math.max(0, Math.min(target, maxScroll));

        if (typeof track.scrollTo === 'function') {
          track.scrollTo({ left: target, behavior: instant ? 'auto' : 'smooth' });
        } else {
          track.scrollLeft = target;
        }
      }

      initLightbox() {
        var self = this;
        if (this.lightbox) return;
        var lb = document.createElement('div');
        lb.className = 'v2pdp_glb';
        lb.setAttribute('aria-hidden', 'true');
        lb.innerHTML =
          '<div class="v2pdp_glb_panel">' +
            '<button class="v2pdp_glb_close" type="button" aria-label="Luk"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
            '<button class="v2pdp_glb_nav v2pdp_glb_prev" type="button" aria-label="Forrige"><svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg></button>' +
            '<div class="v2pdp_glb_stage"><img class="v2pdp_glb_img" alt=""></div>' +
            '<button class="v2pdp_glb_nav v2pdp_glb_next" type="button" aria-label="Næste"><svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg></button>' +
            '<div class="v2pdp_glb_thumbs"></div>' +
          '</div>';
        document.body.appendChild(lb);
        this.lightbox = lb;
        this.glbImg = lb.querySelector('.v2pdp_glb_img');
        this.glbStage = lb.querySelector('.v2pdp_glb_stage');
        this.glbThumbs = lb.querySelector('.v2pdp_glb_thumbs');
        this.lbIndex = 0;

        function bigSrc(img) {
          if (!img) return '';
          var s = img.currentSrc || img.src || '';
          return s.replace(/([?&])width=\d+/, '$1width=2048');
        }
        function unzoom() {
          self.glbImg.classList.remove('is-zoomed');
          self.glbImg.style.transformOrigin = '50% 50%';
        }
        function buildThumbs() {
          self.glbThumbs.innerHTML = '';
          self.lbThumbEls = [];
          var list = self.slides || [];
          list.forEach(function (slide, i) {
            var img = slide.querySelector('.v2_pdp_slide_img, img');
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'v2pdp_glb_thumb';
            b.setAttribute('aria-label', 'Vis billede ' + (i + 1));
            var t = document.createElement('img');
            t.src = img ? (img.currentSrc || img.src || '') : '';
            t.alt = '';
            b.appendChild(t);
            b.addEventListener('click', function (ev) { ev.stopPropagation(); self.lbIndex = i; render(); });
            self.glbThumbs.appendChild(b);
            self.lbThumbEls.push(b);
          });
          self.glbThumbs.style.display = list.length > 1 ? '' : 'none';
        }
        function render() {
          var slide = self.slides && self.slides[self.lbIndex];
          var img = slide && slide.querySelector('.v2_pdp_slide_img, img');
          self.glbImg.src = bigSrc(img);
          self.glbImg.alt = (img && img.alt) || '';
          unzoom();
          var multi = self.slides && self.slides.length > 1;
          lb.querySelectorAll('.v2pdp_glb_nav').forEach(function (b) { b.style.display = multi ? '' : 'none'; });
          if (self.lbThumbEls) {
            self.lbThumbEls.forEach(function (b, i) {
              var on = i === self.lbIndex;
              b.classList.toggle('is-active', on);
              if (on && b.scrollIntoView) { try { b.scrollIntoView({ inline: 'center', block: 'nearest' }); } catch (e) {} }
            });
          }
        }
        function step(d) {
          if (!self.slides || !self.slides.length) return;
          var t = self.slides.length;
          self.lbIndex = ((self.lbIndex + d) % t + t) % t;
          render();
        }
        function close() {
          lb.classList.remove('is-open');
          lb.setAttribute('aria-hidden', 'true');
          document.documentElement.style.overflow = '';
          unzoom();
          if (typeof self.goTo === 'function') self.goTo(self.lbIndex, true);
        }
        this.openLightbox = function (index) {
          if (!self.slides || !self.slides.length) return;
          self.lbIndex = (typeof index === 'number') ? index : (self.index || 0);
          buildThumbs();
          render();
          lb.classList.add('is-open');
          lb.setAttribute('aria-hidden', 'false');
          document.documentElement.style.overflow = 'hidden';
        };

        function setOrigin(cx, cy) {
          var r = self.glbImg.getBoundingClientRect();
          var x = Math.max(0, Math.min(100, ((cx - r.left) / r.width) * 100));
          var y = Math.max(0, Math.min(100, ((cy - r.top) / r.height) * 100));
          self.glbImg.style.transformOrigin = x + '% ' + y + '%';
        }
        self.glbImg.addEventListener('mousemove', function (e) {
          if (self.glbImg.classList.contains('is-zoomed')) setOrigin(e.clientX, e.clientY);
        });

        lb.addEventListener('click', function (e) {
          if (lb._suppressClick) { lb._suppressClick = false; return; }
          if (e.target.closest('.v2pdp_glb_close')) { close(); return; }
          if (e.target.closest('.v2pdp_glb_prev')) { e.stopPropagation(); step(-1); return; }
          if (e.target.closest('.v2pdp_glb_next')) { e.stopPropagation(); step(1); return; }
          if (e.target.closest('.v2pdp_glb_thumb') || e.target.closest('.v2pdp_glb_thumbs')) { return; }
          if (e.target.closest('.v2pdp_glb_img')) {
            e.stopPropagation();
            var zoomed = self.glbImg.classList.toggle('is-zoomed');
            if (zoomed) { setOrigin(e.clientX, e.clientY); } else { self.glbImg.style.transformOrigin = '50% 50%'; }
            return;
          }
          // Click on the dimmed backdrop (outside the panel) closes; clicks inside the panel do not.
          if (!e.target.closest('.v2pdp_glb_panel')) { close(); }
        });

        document.addEventListener('keydown', function (e) {
          if (!lb.classList.contains('is-open')) return;
          if (e.key === 'Escape') close();
          else if (e.key === 'ArrowLeft') step(-1);
          else if (e.key === 'ArrowRight') step(1);
        });

        // Touch swipe to change image (mobile); ignored while zoomed or pinching.
        var sx = 0, sy = 0, sActive = false, sDecided = false, sHoriz = false;
        self.glbStage.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1 || self.glbImg.classList.contains('is-zoomed')) { sActive = false; return; }
          sx = e.touches[0].clientX; sy = e.touches[0].clientY;
          sActive = true; sDecided = false; sHoriz = false;
          self.glbImg.style.transition = 'none';
        }, { passive: true });
        self.glbStage.addEventListener('touchmove', function (e) {
          if (!sActive || e.touches.length !== 1) { sActive = false; self.glbImg.style.transform = ''; return; }
          var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
          if (!sDecided) { if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return; sDecided = true; sHoriz = Math.abs(dx) > Math.abs(dy); }
          if (sHoriz) { if (e.cancelable) e.preventDefault(); self.glbImg.style.transform = 'translateX(' + dx + 'px)'; }
        }, { passive: false });
        function endSwipe(e) {
          if (!sActive) return;
          sActive = false;
          self.glbImg.style.transition = '';
          self.glbImg.style.transform = '';
          var dx = (e.changedTouches && e.changedTouches[0]) ? (e.changedTouches[0].clientX - sx) : 0;
          if (sHoriz && Math.abs(dx) > 45) {
            lb._suppressClick = true;
            if (self.slides && self.slides.length > 1) step(dx < 0 ? 1 : -1);
          }
        }
        self.glbStage.addEventListener('touchend', endSwipe, { passive: true });
        self.glbStage.addEventListener('touchcancel', endSwipe, { passive: true });
      }

      setColorOption(btn) {
        var blockId = btn.dataset.colorBlock;
        var colorName = btn.dataset.optionValue || '';
        this.querySelectorAll('[data-swatch-group="page"] .v2_pdp_swatch').forEach(function (swatch) {
          var on = swatch === btn;
          swatch.classList.toggle('is-selected', on);
          swatch.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var selectedLabel = this.querySelector('.v2_pdp_swatch_selected--desktop');
        if (selectedLabel && colorName) selectedLabel.textContent = colorName;

        this.querySelectorAll('.v2_pdp_color_gallery').forEach(function (gallery) {
          gallery.hidden = gallery.dataset.colorBlock !== blockId;
        });
        this.bindActiveGallery(true);

        if (!colorName) return;
        var variant = this.findVariant(colorName);
        if (!variant) return;
        this.selectedVariantId = variant.id;
        if (this.variantInput) this.variantInput.value = variant.id;
        this.querySelectorAll('.v2_pdp_buy_buttons input[name="id"], .v2_pdp_buy_buttons .main-product-variant-input').forEach(function (input) {
          input.value = variant.id;
        });
        if (variant.featured_image && this.modalImg) this.modalImg.src = variant.featured_image;
        this.applySoldOut(colorName);
      }

      initSwatches() {
        var self = this;
        this.querySelectorAll('.v2_pdp_swatch').forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (btn.dataset.colorBlock) {
              self.setColorOption(btn);
              return;
            }
            var source = btn.closest('.v2_pdp_swatches--modal') ? 'modal' : 'page';
            self.setVariant(btn.dataset.optionValue, source);
          });
        });
      }

      getSelectedVariantId() {
        if (this.variantInput && this.variantInput.value) return this.variantInput.value;
        var selected = this.querySelector('[data-swatch-group="page"] .v2_pdp_swatch.is-selected');
        if (selected) {
          var variant = this.findVariant(selected.dataset.optionValue);
          if (variant) return variant.id;
        }
        return this.selectedVariantId || (this.data.variants[0] && this.data.variants[0].id);
      }

      addToCartAndCheckout(email) {
        var self = this;
        if (this._checkoutPending) return Promise.reject(new Error('Checkout pending'));
        var id = this.reservationVariantId;
        if (!id) return Promise.reject(new Error('Missing reservation variant'));
        var item = { id: Number(id), quantity: 1 };
        if (this.reservationSellingPlanId) item.selling_plan = this.reservationSellingPlanId;
        this._checkoutPending = true;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed');
            var checkoutUrl = new URL('/checkout', window.location.origin);
            if (email) checkoutUrl.searchParams.set('checkout[email]', email);

            // Mark the redirect before assigning the URL. Some browsers report an
            // aborted promise while unloading even though Shopify Checkout opened.
            // That must never be presented to the customer as a checkout failure.
            self._redirectingToCheckout = true;
            window.location.assign(checkoutUrl.toString());

            // Keep this promise pending while the document navigates. This prevents
            // a successful redirect/unload from reaching either checkout error UI.
            return new Promise(function () {});
          })
          .catch(function (error) {
            if (self._redirectingToCheckout) return new Promise(function () {});
            self._checkoutPending = false;
            throw error;
          });
      }

      initReserve() {
        var self = this;
        var forms = this.querySelectorAll('.v2_pdp_reserve_form, .v2_pdp_reservation_checkout_form');
        forms.forEach(function (form) {
          form.addEventListener('submit', function (event) {
            event.preventDefault();
            self.addToCartAndCheckout().catch(function () {});
          });
        });
      }

      initReserveCta() {
        var self = this;
        var btn = this.querySelector('.v2_pdp_reserve_now_btn');
        if (!btn) return;
        btn.addEventListener('click', function () {
          if (self.modal) {
            self.openModal();
            return;
          }
          var form = self.querySelector('.v2_pdp_reserve_form');
          if (form) form.requestSubmit();
        });
      }

      initModal() {
        var self = this;
        var closeBtn = this.querySelector('.v2_pdp_modal_close');
        if (closeBtn) closeBtn.addEventListener('click', function () { self.modal.close(); });
        if (this.modal) {
          this.modal.addEventListener('click', function (event) {
            if (event.target === self.modal) self.modal.close();
          });
        }
      }

      initGiftSelectionModal() {
        var self = this;
        if (!this.giftModal) return;

        var buyWrap = this.querySelector('.v2_pdp_buy_buttons');
        var buyForm = buyWrap ? buyWrap.querySelector('form') : null;
        var termsInput = this.giftModal.querySelector('[data-gift-terms]');
        var buyBtn = this.giftModal.querySelector('[data-gift-buy]');
        var closeBtn = this.giftModal.querySelector('.v2_pdp_gift_modal__close');
        var selectedVariantBtn = this.giftModal.querySelector('.v2_pdp_gift_modal__variant.is-selected');

        this.selectedGiftVariantId = selectedVariantBtn
          ? Number(selectedVariantBtn.dataset.giftVariantId)
          : 0;

        function syncBuyEnabled() {
          if (!buyBtn) return;
          if (self._giftAtcPending) {
            buyBtn.disabled = true;
            return;
          }
          if (!termsInput) {
            buyBtn.disabled = !self.selectedGiftVariantId;
            return;
          }
          buyBtn.disabled = !(termsInput.checked && self.selectedGiftVariantId);
        }

        function lockPageScroll() {
          if (document.documentElement.dataset.v2GiftScrollLock === '1') return;
          document.documentElement.dataset.v2GiftScrollLock = '1';
          document.documentElement.style.overflow = 'hidden';
          document.body.style.overflow = 'hidden';
        }

        function unlockPageScroll() {
          if (document.documentElement.dataset.v2GiftScrollLock !== '1') return;
          delete document.documentElement.dataset.v2GiftScrollLock;
          document.documentElement.style.overflow = '';
          document.body.style.overflow = '';
        }

        function openGiftModal(event) {
          if (event) {
            event.preventDefault();
            event.stopPropagation();
            if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
          }
          if (!self.giftModal) return;
          if (self.giftModal.parentNode !== document.body) {
            document.body.appendChild(self.giftModal);
          }
          lockPageScroll();
          requestAnimationFrame(function () {
            try {
              if (typeof self.giftModal.showModal === 'function') {
                if (!self.giftModal.open) self.giftModal.showModal();
              } else {
                self.giftModal.setAttribute('open', '');
              }
            } catch (err) {
              self.giftModal.setAttribute('open', '');
            }
          });
        }

        if (buyForm) {
          buyForm.addEventListener('submit', openGiftModal, true);
        }
        if (buyWrap) {
          buyWrap.addEventListener('click', function (event) {
            var submitBtn = event.target.closest('button[type="submit"], .button[type="submit"], button.button');
            if (!submitBtn || submitBtn.closest('.v2_pdp_gift_modal')) return;
            openGiftModal(event);
          }, true);
        }
        this.querySelectorAll('[data-gift-open]').forEach(function (el) {
          el.addEventListener('click', function (event) {
            openGiftModal(event);
          });
          el.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
              openGiftModal(event);
            }
          });
        });

        this.giftModal.querySelectorAll('.v2_pdp_gift_modal__variant').forEach(function (btn) {
          btn.addEventListener('click', function () {
            self.giftModal.querySelectorAll('.v2_pdp_gift_modal__variant').forEach(function (el) {
              el.classList.remove('is-selected');
              el.setAttribute('aria-selected', 'false');
            });
            btn.classList.add('is-selected');
            btn.setAttribute('aria-selected', 'true');
            self.selectedGiftVariantId = Number(btn.dataset.giftVariantId || 0);
            syncBuyEnabled();
          });
        });

        if (termsInput) {
          termsInput.addEventListener('change', syncBuyEnabled);
        }

        if (closeBtn) {
          closeBtn.addEventListener('click', function () { self.giftModal.close(); });
        }
        this.giftModal.addEventListener('click', function (event) {
          if (event.target === self.giftModal) self.giftModal.close();
        });
        this.giftModal.addEventListener('close', unlockPageScroll);
        this.giftModal.addEventListener('cancel', unlockPageScroll);

        if (buyBtn) {
          buyBtn.addEventListener('click', function () {
            self.addMainAndGiftToCart(buyBtn);
          });
        }

        syncBuyEnabled();
      }

      initDirectBuy() {
        var self = this;
        if (this.giftModal) return;
        var buyWrap = this.querySelector('.v2_pdp_buy_buttons');
        var buyForm = buyWrap ? buyWrap.querySelector('form') : null;
        if (!buyForm) return;
        var action = (buyWrap.getAttribute('data-cta-action') || 'checkout');
        buyForm.addEventListener('submit', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
          if (self._soldOut) return;
          self.addMainProduct(action === 'checkout');
        }, true);
      }

      initStickyChooseColor() {
        var sticky = document.querySelector('product-quick-add.pdp_v1_sticky_buy[data-section-id="' + this.dataset.sectionId + '"]');
        if (!sticky || sticky.dataset.stickyChoose !== 'true') return;
        var self = this;
        sticky.querySelectorAll('.pdp_v1_sticky_choose').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
            var target = self.querySelector('.v2_pdp_swatches[data-swatch-group="page"]') || self.querySelector('.v2_pdp_swatches');
            if (!target) return;
            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            var firstSwatch = target.querySelector('.v2_pdp_swatch');
            if (firstSwatch) { try { firstSwatch.focus({ preventScroll: true }); } catch (err) {} }
          }, true);
        });
      }

      initStickyColorModal() {
        var self = this;
        var modal = document.querySelector('[data-color-buy-modal][data-section-id="' + this.dataset.sectionId + '"]');
        if (!modal) return;
        this.cbm = modal;
        var sticky = document.querySelector('product-quick-add.pdp_v1_sticky_buy[data-section-id="' + this.dataset.sectionId + '"]');
        var buyBtn = modal.querySelector('[data-color-buy]');
        var buyLabel = buyBtn ? buyBtn.querySelector('.v2_pdp_gift_modal__buy-label') : null;
        var termsInput = modal.querySelector('[data-gift-terms]');
        var cards = modal.querySelectorAll('.v2_pdp_gift_modal__variant');
        if (buyLabel) this._cbmBtnText = buyLabel.textContent;

        function currentColor() {
          var c = modal.querySelector('.v2_pdp_gift_modal__variant.is-selected');
          return c ? c.dataset.optionValue : null;
        }
        function isSoldOut(color) {
          return !!(self.soldOutColors && color && self.soldOutColors.indexOf(String(color).toLowerCase()) !== -1);
        }
        function syncBuy() {
          if (!buyBtn) return;
          var color = currentColor();
          var sold = isSoldOut(color);
          var ok = !!color && !sold && (!termsInput || termsInput.checked);
          buyBtn.disabled = !ok;
          buyBtn.classList.toggle('is-color-soldout', sold);
          if (buyLabel) buyLabel.textContent = sold ? self.soldOutLabel : (self._cbmBtnText || buyLabel.textContent);
        }
        function selectColor(color, syncMain) {
          cards.forEach(function (c) {
            var on = c.dataset.optionValue === color;
            c.classList.toggle('is-selected', on);
            c.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          if (syncMain !== false && color) self.setVariant(color, 'page');
          syncBuy();
        }
        this._cbmSelectColor = selectColor;

        function lockScroll() { document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden'; }
        function unlockScroll() { document.documentElement.style.overflow = ''; document.body.style.overflow = ''; }

        function openCbm(e) {
          // Opens on all screen sizes — the sticky cart (mobile AND desktop) opens the colour popup.
          if (e) { e.preventDefault(); e.stopPropagation(); if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation(); }
          var pageSel = self.querySelector('.v2_pdp_swatches[data-swatch-group="page"] .v2_pdp_swatch.is-selected');
          if (pageSel) selectColor(pageSel.dataset.optionValue, false);
          if (modal.parentNode !== document.body) document.body.appendChild(modal);
          lockScroll();
          try {
            if (typeof modal.showModal === 'function') { if (!modal.open) modal.showModal(); }
            else { modal.setAttribute('open', ''); }
          } catch (err) { modal.setAttribute('open', ''); }
        }
        function closeCbm() {
          try { if (modal.open && typeof modal.close === 'function') modal.close(); else modal.removeAttribute('open'); }
          catch (e) { modal.removeAttribute('open'); }
          unlockScroll();
        }
        this.closeCbm = closeCbm;

        cards.forEach(function (card) {
          card.addEventListener('click', function () { selectColor(card.dataset.optionValue, true); });
        });
        if (termsInput) termsInput.addEventListener('change', syncBuy);

        if (sticky) {
          sticky.addEventListener('click', function (e) {
            var btn = e.target.closest('.pdp_v1_sticky_buy_btn, button[type="submit"], .button');
            if (!btn) return;
            openCbm(e);
          }, true);
        }

        var closeBtn = modal.querySelector('.v2_pdp_gift_modal__close');
        if (closeBtn) closeBtn.addEventListener('click', closeCbm);
        modal.addEventListener('click', function (e) { if (e.target === modal) closeCbm(); });
        modal.addEventListener('cancel', closeCbm);
        modal.addEventListener('close', unlockScroll);

        if (buyBtn) buyBtn.addEventListener('click', function () {
          if (buyBtn.disabled || self._soldOut) return;
          closeCbm();
          self.addMainProduct(true); // mobile: go straight to checkout
        });

        // initial state reflects the currently selected colour
        selectColor(currentColor(), false);
      }

      addMainAndGiftToCart(buyBtn) {
        var self = this;
        if (this._giftAtcPending) return;
        var giftId = Number(this.selectedGiftVariantId || 0);
        if (!giftId) return;

        var termsInput = this.giftModal && this.giftModal.querySelector('[data-gift-terms]');
        if (termsInput && !termsInput.checked) return;

        this._giftAtcPending = true;
        if (this.giftModal) this.giftModal.classList.add('is-adding');
        if (buyBtn) {
          buyBtn.disabled = true;
          buyBtn.setAttribute('aria-busy', 'true');
        }

        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
        var addWithMain = this.giftModal && this.giftModal.getAttribute('data-add-with-main') === 'true';
        var items = [];

        if (addWithMain) {
          var mainId = Number(this.getSelectedVariantId() || 0);
          if (!mainId) {
            this._giftAtcPending = false;
            if (this.giftModal) this.giftModal.classList.remove('is-adding');
            if (buyBtn) {
              buyBtn.removeAttribute('aria-busy');
              var termsReset = this.giftModal && this.giftModal.querySelector('[data-gift-terms]');
              buyBtn.disabled = !!(termsReset && !termsReset.checked);
            }
            return;
          }
          var bundleId = 'gift-' + Date.now() + '-' + Math.random().toString(36).slice(2, 9);
          items.push({
            id: mainId,
            quantity: 1,
            properties: { _addon_bundle_id: bundleId }
          });
          items.push({
            id: giftId,
            quantity: 1,
            properties: { _free_gift: 'True', _addon_bundle_id: bundleId }
          });
        } else {
          items.push({ id: giftId, quantity: 1 });
        }

        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            return response.json().then(function (json) {
              if (!response.ok) throw new Error((json && json.description) || 'Add to cart failed');
              return json;
            });
          })
          .then(function () {
            // Redirect straight to checkout (skip cart drawer) after items are added.
            self._giftRedirectingToCheckout = true;
            if (self.giftModal && self.giftModal.open && typeof self.giftModal.close === 'function') {
              try { self.giftModal.close(); } catch (err) {}
            }
            window.location.assign(root + 'checkout');
            // Keep the promise pending while the document navigates so the button
            // does not briefly re-enable before checkout loads.
            return new Promise(function () {});
          })
          .catch(function (error) {
            if (self._giftRedirectingToCheckout) return new Promise(function () {});
            console.error(error);
            alert('Kunne ikke starte checkout. Prøv igen.');
            self._giftAtcPending = false;
            if (self.giftModal) self.giftModal.classList.remove('is-adding');
            if (buyBtn) {
              buyBtn.removeAttribute('aria-busy');
              var terms = self.giftModal && self.giftModal.querySelector('[data-gift-terms]');
              buyBtn.disabled = !!(terms && !terms.checked);
            }
          });
      }

      addMainProduct(goToCheckout) {
        var self = this;
        if (this._giftAtcPending) return;
        var mainId = Number(this.getSelectedVariantId() || 0);
        if (!mainId) return;

        var buyBtn = this.querySelector('.v2_pdp_buy_buttons button[type="submit"], .v2_pdp_buy_buttons .button');
        this._giftAtcPending = true;
        if (buyBtn) {
          buyBtn.disabled = true;
          buyBtn.setAttribute('aria-busy', 'true');
        }

        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [{ id: mainId, quantity: 1 }],
            sections: ['cart-drawer', 'variant-added'],
            sections_url: window.location.pathname
          })
        })
          .then(function (response) {
            return response.json().then(function (json) {
              if (!response.ok) throw new Error((json && json.description) || 'Add to cart failed');
              return json;
            });
          })
          .then(function (added) {
            if (goToCheckout) {
              self._giftRedirectingToCheckout = true;
              window.location.assign(root.replace(/\/?$/, '/') + 'checkout');
              return new Promise(function () {});
            }
            return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              var sections = added && added.sections;
              var attachAndDispatch = function (cartWithSections) {
                var addedItems = added.items ? added.items : [added];
                document.documentElement.dispatchEvent(new CustomEvent('variant:add', {
                  bubbles: true,
                  detail: { items: addedItems, cart: cartWithSections }
                }));
                document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
                  bubbles: true,
                  detail: { baseEvent: 'variant:add', cart: cartWithSections }
                }));
              };
              if (sections && sections['cart-drawer']) {
                cart.sections = sections;
                attachAndDispatch(cart);
                return;
              }
              return fetch(root + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (sectionData) {
                cart.sections = sectionData || {};
                attachAndDispatch(cart);
              });
            });
          })
          .catch(function (error) {
            if (self._giftRedirectingToCheckout) return;
            console.error(error);
            alert('Kunne ikke tilføje produktet til kurven. Prøv igen.');
          })
          .finally(function () {
            if (self._giftRedirectingToCheckout) return;
            self._giftAtcPending = false;
            if (buyBtn) {
              buyBtn.disabled = false;
              buyBtn.removeAttribute('aria-busy');
            }
          });
      }

      initEmailFormCheckout() {
        var self = this;
        var form = this.querySelector('.v2_pdp_email_form:not([data-klaviyo-custom])');
        if (!form) return;
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          var body = new FormData(form);
          fetch(form.action || window.location.pathname, {
            method: 'POST',
            body: body,
            headers: { Accept: 'application/json' }
          })
            .catch(function () {})
            .finally(function () {
              self.addToCartAndCheckout().catch(function () {});
            });
        });
      }

      openModal() {
        var selected = this.querySelector('[data-swatch-group="page"] .v2_pdp_swatch.is-selected');
        if (selected) this.setVariant(selected.dataset.optionValue, 'modal');
        if (this.modal && !this.modal.open) this.modal.showModal();
      }
    }

    if (!customElements.get('pdp-design-v1')) {
      customElements.define('pdp-design-v1', V2SignaturePdp);
    }
  })();

  /* PDP Design V1 — Klaviyo (kept separate at end of section) */
  (function () {
    function ensureKlaviyo(companyId) {
      return new Promise(function (resolve, reject) {
        if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
          resolve(window.klaviyo);
          return;
        }
        if (!companyId) {
          reject(new Error('Missing Klaviyo company ID'));
          return;
        }
        window._klOnsite = window._klOnsite || [];
        var existing = document.querySelector('script[data-v2-klaviyo-onsite]');
        if (!existing) {
          var script = document.createElement('script');
          script.async = true;
          script.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=' + encodeURIComponent(companyId);
          script.setAttribute('data-v2-klaviyo-onsite', 'true');
          document.head.appendChild(script);
        }
        var tries = 0;
        var timer = setInterval(function () {
          tries += 1;
          if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
            clearInterval(timer);
            resolve(window.klaviyo);
          } else if (tries > 50) {
            clearInterval(timer);
            reject(new Error('Klaviyo failed to load'));
          }
        }, 100);
      });
    }

    function colorPropertyPrefix(value) {
      var prefix = String(value || 'w5_signature').trim().replace(/[^a-zA-Z0-9_]/g, '');
      return prefix || 'w5_signature';
    }

    function colorProfileProperties(prefix, color, variantId, market, selectedAt, checkoutUrl) {
      var base = colorPropertyPrefix(prefix);
      var properties = {};
      properties[base + '_status'] = 'color_selected';
      properties[base + '_color'] = color;
      properties[base + '_variant_id'] = String(variantId);
      properties[base + '_market'] = market;
      properties[base + '_selected_at'] = selectedAt;
      properties[base + '_checkout_url'] = checkoutUrl;
      return properties;
    }

    function saveW5ColorSelection(payload, companyId) {
      var email = String(payload.email || '').trim().toLowerCase();
      var color = payload.color;
      var variantId = payload.variantId;
      var market = payload.market || 'DK';
      var checkoutUrl = payload.checkoutUrl || '';
      var selectedAt = new Date().toISOString();
      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = controller
        ? setTimeout(function () { controller.abort(); }, 8000)
        : null;

      return fetch('https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          revision: '2024-10-15'
        },
        signal: controller ? controller.signal : undefined,
        body: JSON.stringify({
          data: {
            type: 'profile',
            attributes: {
              email: email,
              properties: colorProfileProperties(payload.prefix, color, variantId, market, selectedAt, checkoutUrl)
            }
          }
        })
      })
        .then(function (response) {
          if (response.ok || response.status === 202) {
            return {
              success: true,
              email: email,
              color: color,
              checkoutUrl: checkoutUrl
            };
          }
          throw new Error('Klaviyo profile update failed with status ' + response.status);
        })
        .finally(function () {
          if (timer) clearTimeout(timer);
        });
    }

    function initCustomKlaviyoForm(root) {
      var form = root.querySelector('[data-klaviyo-custom="true"]');
      if (!form || form._v2KlaviyoReady) return;
      form._v2KlaviyoReady = true;
      var emailInput = form.querySelector('input[type="email"]');
      var button = form.querySelector('button[type="submit"]');
      var message = form.querySelector('.v2_pdp_klaviyo_message');
      var companyId = (form.dataset.klaviyoCompany || '').trim();
      var listId = (form.dataset.klaviyoList || '').trim();
      var buttonLabel = button ? button.textContent : '';

      function showError(text) {
        if (!message) return;
        message.hidden = false;
        message.textContent = text;
        message.classList.add('is-error');
      }

      function setBusy(busy) {
        if (!button) return;
        button.disabled = busy;
        button.textContent = busy ? '...' : buttonLabel;
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var email = emailInput ? emailInput.value.trim() : '';
        if (!email || email.indexOf('@') === -1) {
          showError('Indtast en gyldig e-mail.');
          if (emailInput) emailInput.focus();
          return;
        }
        if (message) {
          message.hidden = true;
          message.textContent = '';
          message.classList.remove('is-error');
        }
        setBusy(true);

        var timezone = '';
        try {
          timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
        } catch (err) {}

        var variantId = Number(root.getSelectedVariantId ? root.getSelectedVariantId() : 0);
        var variant = ((root.data && root.data.variants) || []).find(function (item) {
          return item.id === variantId;
        });
        var selectedSwatch = root.querySelector('[data-swatch-group="page"] .v2_pdp_swatch.is-selected');
        var color = (selectedSwatch && selectedSwatch.dataset.optionValue)
          || (variant && (variant.option1 || variant.title))
          || '';

        var location = {};
        if (form.dataset.countryName) location.country = form.dataset.countryName;
        if (timezone) location.timezone = timezone;

        var properties = {
          wavell_5_signature: true,
          product: form.dataset.product || '',
          product_handle: form.dataset.productHandle || '',
          color: color,
          variant_id: variant ? variant.id : '',
          variant_title: variant ? variant.title : '',
          country: form.dataset.countryName || '',
          country_code: form.dataset.country || '',
          language: form.dataset.language || '',
          currency: form.dataset.currency || '',
          timezone: timezone,
          page_url: form.dataset.pageUrl || window.location.href
        };

        var profileAttributes = {
          email: email,
          properties: properties
        };
        if (form.dataset.language) profileAttributes.locale = form.dataset.language;
        if (location.country || location.timezone) profileAttributes.location = location;

        var subscriptionController = typeof AbortController === 'function' ? new AbortController() : null;
        var subscriptionTimer = subscriptionController
          ? setTimeout(function () { subscriptionController.abort(); }, 5000)
          : null;
        var subscriptionRequest = fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(companyId), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2024-10-15'
          },
          signal: subscriptionController ? subscriptionController.signal : undefined,
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Wavell 5 Signature PDP',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: profileAttributes
                  }
                }
              },
              relationships: {
                list: {
                  data: { type: 'list', id: listId }
                }
              }
            }
          })
        })
          .then(function (response) {
            if (response.ok || response.status === 202) return true;
            throw new Error('Klaviyo subscribe failed');
          })
          .catch(function (error) {
            // Privacy tools can block Klaviyo. Shopify checkout must still remain
            // available; its customer record can sync to Klaviyo after purchase.
            console.warn('W5 Klaviyo subscription was deferred.', error);
            return false;
          });

        subscriptionRequest
          .then(function () {
            if (subscriptionTimer) clearTimeout(subscriptionTimer);
            if (root.addToCartAndCheckout) return root.addToCartAndCheckout(email);
            throw new Error('Checkout is unavailable');
          })
          .catch(function () {
            if (subscriptionTimer) clearTimeout(subscriptionTimer);
            setBusy(false);
            showError('Vi kunne ikke starte Shopify Checkout. Opdater siden og prøv igen.');
          });
      }, true);
    }

    function initColorSelectionSubmit(root) {
      var box = root.querySelector('[data-color-selection-submit]');
      if (!box) return;

      var form = box.querySelector('.v2_pdp_color_submit_form');
      var button = box.querySelector('.v2_pdp_color_submit_btn');
      var message = box.querySelector('.v2_pdp_color_submit_message');
      var buttonLabel = button ? button.textContent.trim() : '';
      var loadingText = box.dataset.loadingText || 'Sender...';
      var companyId = (box.dataset.klaviyoCompany || '').trim();
      var storageKey = box.dataset.emailStorageKey || 'w5_signature_email';
      var storageExpiryKey = storageKey + '_expires_at';
      var storageLifetime = 30 * 24 * 60 * 60 * 1000;
      var travelCaseVariantId = String(box.dataset.travelCaseVariantId || '').trim();
      var propertyPrefix = colorPropertyPrefix(box.dataset.propertyPrefix);
      if (!form || form._v2KlaviyoReady) return;
      form._v2KlaviyoReady = true;

      function normalizeEmail(value) {
        var raw = String(value || '').trim();
        if (!raw) return '';
        try {
          raw = decodeURIComponent(raw);
        } catch (err) {}
        return String(raw || '').trim().toLowerCase();
      }

      function isValidEmail(value) {
        var email = normalizeEmail(value);
        return !!email && email.indexOf('@') !== -1;
      }

      function setCookie(name, value, days) {
        try {
          var maxAge = (days || 30) * 24 * 60 * 60;
          var cookieValue = [
            name,
            '=',
            encodeURIComponent(value),
            '; path=/; max-age=',
            String(maxAge),
            '; SameSite=Lax'
          ].join('');
          if (window.location.protocol === 'https:') cookieValue += '; Secure';
          document['cookie'] = cookieValue;
        } catch (err) {}
      }

      function getCookie(name) {
        try {
          var allCookies = String(document['cookie'] || '');
          var parts = allCookies.split(';');
          for (var i = 0; i < parts.length; i++) {
            var part = parts[i].trim();
            if (part.indexOf(name + '=') === 0) {
              return decodeURIComponent(part.slice(name.length + 1));
            }
          }
        } catch (err) {}
        return '';
      }

      function storeEmail(email) {
        var clean = normalizeEmail(email);
        if (!isValidEmail(clean)) return '';
        try {
          localStorage.setItem(storageKey, clean);
          localStorage.setItem(storageExpiryKey, String(Date.now() + storageLifetime));
        } catch (err) {}
        setCookie(storageKey, clean, 30);
        return clean;
      }

      function readStoredEmail() {
        var fromStorage = '';
        try {
          var expiresAt = Number(localStorage.getItem(storageExpiryKey) || 0);
          if (expiresAt && expiresAt <= Date.now()) {
            localStorage.removeItem(storageKey);
            localStorage.removeItem(storageExpiryKey);
          } else {
            fromStorage = localStorage.getItem(storageKey) || '';
            if (isValidEmail(fromStorage) && !expiresAt) {
              localStorage.setItem(storageExpiryKey, String(Date.now() + storageLifetime));
            }
          }
        } catch (err) {}
        if (isValidEmail(fromStorage)) return normalizeEmail(fromStorage);
        var fromCookie = getCookie(storageKey);
        if (isValidEmail(fromCookie)) return normalizeEmail(fromCookie);
        return '';
      }

      function captureEmailFromUrl() {
        try {
          var params = new URLSearchParams(window.location.search);
          var rawEmailMatch = window.location.search.match(/[?&](?:email|e)=([^&#]*)/i);
          var emailFromUrl = params.get('email') || params.get('e') || '';
          if (rawEmailMatch && rawEmailMatch[1]) {
            try {
              emailFromUrl = decodeURIComponent(rawEmailMatch[1]);
            } catch (err) {
              emailFromUrl = rawEmailMatch[1];
            }
          } else {
            var bareEmail = window.location.search.slice(1).split('&')[0] || '';
            if (bareEmail && bareEmail.indexOf('=') === -1) {
              try {
                bareEmail = decodeURIComponent(bareEmail);
              } catch (err) {}
              if (bareEmail.indexOf('@') !== -1) emailFromUrl = bareEmail;
            }
          }
          emailFromUrl = normalizeEmail(emailFromUrl);
          if (isValidEmail(emailFromUrl)) {
            return storeEmail(emailFromUrl);
          }
        } catch (err) {}
        return '';
      }

      function clearEmailFromUrl() {
        try {
          var params = new URLSearchParams(window.location.search);
          var bareEmailKey = '';
          params.forEach(function (value, key) {
            if (!value && key.indexOf('@') !== -1) bareEmailKey = key;
          });
          if (!params.has('email') && !params.has('e') && !bareEmailKey) return;
          params.delete('email');
          params.delete('e');
          if (bareEmailKey) params.delete(bareEmailKey);
          var cleanQuery = params.toString();
          var cleanUrl = window.location.pathname + (cleanQuery ? '?' + cleanQuery : '') + window.location.hash;
          window.history.replaceState(window.history.state, document.title, cleanUrl);
        } catch (err) {}
      }

      var email = captureEmailFromUrl() || readStoredEmail();

      function showMessage(text, isError) {
        if (!message) return;
        message.hidden = !text;
        message.textContent = text || '';
        message.classList.toggle('is-error', !!isError);
      }

      function setBusy(busy) {
        if (!button) return;
        button.disabled = busy;
        button.textContent = busy ? loadingText : buttonLabel;
      }

      function findExactVariant(color) {
        var variants = (root.data && root.data.variants) || [];
        var key = 'option' + (root.colorOption || 1);
        return variants.find(function (variant) {
          return variant[key] === color || variant.title === color;
        }) || null;
      }

      function buildCheckoutUrl(emailAddress, color, variantId, market) {
        if (!travelCaseVariantId || !/^\d+$/.test(travelCaseVariantId)) {
          throw new Error('Missing Travel Case variant');
        }
        var base = colorPropertyPrefix(propertyPrefix);
        var items = String(variantId) + ':1,' + travelCaseVariantId + ':1';
        var checkoutUrl = new URL('/cart/' + items, window.location.origin);
        checkoutUrl.searchParams.set('checkout[email]', emailAddress);
        checkoutUrl.searchParams.set('attributes[' + base + '_color]', color);
        checkoutUrl.searchParams.set('attributes[' + base + '_market]', market);
        checkoutUrl.searchParams.set('ref', base.replace(/_/g, '-') + '-final');
        return checkoutUrl.toString();
      }

      function showSuccess(color, checkoutUrl) {
        var successText = box.dataset.successMessage || '[color] er gemt. Vi sender dit checkout-link på lanceringsdagen.';
        var resolvedText = successText.replace(/\[color\]/g, color);
        showMessage('', false);
        if (message) {
          message.hidden = false;
          message.classList.remove('is-error');
          message.textContent = '';
          var card = document.createElement('div');
          card.className = 'v2_pdp_color_submit_success';
          var icon = document.createElement('span');
          icon.className = 'v2_pdp_color_submit_success_icon';
          icon.setAttribute('aria-hidden', 'true');
          icon.textContent = '✓';
          var copy = document.createElement('div');
          var title = document.createElement('strong');
          title.className = 'v2_pdp_color_submit_success_title';
          title.textContent = box.dataset.successTitle || 'Din farve er gemt';
          var text = document.createElement('p');
          text.className = 'v2_pdp_color_submit_success_text';
          text.textContent = resolvedText;
          copy.appendChild(title);
          copy.appendChild(text);
          card.appendChild(icon);
          card.appendChild(copy);
          message.appendChild(card);
        }
        var params = new URLSearchParams(window.location.search);
        if (params.get('w5_test') !== '1' || !message) return;
        var link = document.createElement('a');
        link.href = checkoutUrl;
        link.textContent = 'Test checkout-link';
        link.style.display = 'block';
        link.style.marginTop = '8px';
        message.appendChild(link);
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        email = captureEmailFromUrl() || readStoredEmail() || email;
        var selectedSwatch = root.querySelector('[data-swatch-group="page"] .v2_pdp_swatch.is-selected');
        var color = selectedSwatch ? selectedSwatch.dataset.optionValue : '';
        var selectedVariant = color ? findExactVariant(color) : null;
        var variantId = selectedVariant ? selectedVariant.id : '';
        var market = box.dataset.market || 'DK';
        var checkoutUrl = '';

        if (!isValidEmail(email)) {
          showMessage(box.dataset.missingEmail || 'Missing email. Open your reservation link again.', true);
          return;
        }
        if (!color) {
          showMessage(box.dataset.missingColor || 'Select a color first.', true);
          return;
        }
        if (!selectedVariant) {
          showMessage(box.dataset.missingVariant || 'The selected color is not configured.', true);
          return;
        }
        try {
          checkoutUrl = buildCheckoutUrl(email, color, variantId, market);
        } catch (err) {
          showMessage(box.dataset.missingVariant || 'The selected color is not configured.', true);
          return;
        }

        showMessage('', false);
        setBusy(true);

        saveW5ColorSelection({
          email: email,
          color: color,
          variantId: variantId,
          market: market,
          checkoutUrl: checkoutUrl,
          prefix: propertyPrefix
        }, companyId)
          .then(function () {
            box.classList.add('is-success');
            clearEmailFromUrl();
            showSuccess(color, checkoutUrl);
            setBusy(false);
          })
          .catch(function () {
            setBusy(false);
            showMessage(box.dataset.errorMessage || 'Something went wrong. Try again.', true);
          });
      }, true);
    }

    function initBackInStockForm(form) {
      if (!form || form._bisReady) return;
      form._bisReady = true;
      var emailInput = form.querySelector('input[type="email"]');
      var button = form.querySelector('button[type="submit"]');
      var message = form.querySelector('.v2_pdp_bis__message');
      var companyId = (form.dataset.klaviyoCompany || '').trim();
      var listId = (form.dataset.klaviyoList || '').trim();
      var successText = form.dataset.success || 'Tak! Vi giver dig besked.';
      var buttonLabel = button ? button.textContent : '';

      function showError(text) {
        if (!message) return;
        message.hidden = false;
        message.textContent = text;
        message.classList.add('is-error');
      }
      function clearMsg() {
        if (!message) return;
        message.hidden = true;
        message.textContent = '';
        message.classList.remove('is-error');
      }
      function setBusy(busy) {
        if (!button) return;
        button.disabled = busy;
        button.textContent = busy ? '...' : buttonLabel;
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var email = emailInput ? emailInput.value.trim() : '';
        if (!email || email.indexOf('@') === -1) {
          showError('Indtast en gyldig e-mail.');
          if (emailInput) emailInput.focus();
          return;
        }
        if (!companyId || !listId) {
          showError('Noget gik galt. Prøv igen.');
          return;
        }
        clearMsg();
        setBusy(true);

        var timezone = '';
        try { timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (err) {}

        var properties = {
          back_in_stock: true,
          product: form.dataset.product || '',
          product_handle: form.dataset.productHandle || '',
          country: form.dataset.countryName || '',
          country_code: form.dataset.country || '',
          language: form.dataset.language || '',
          currency: form.dataset.currency || '',
          page_url: window.location.href
        };
        var profileAttributes = { email: email, properties: properties };
        if (form.dataset.language) profileAttributes.locale = form.dataset.language;
        var location = {};
        if (form.dataset.countryName) location.country = form.dataset.countryName;
        if (timezone) location.timezone = timezone;
        if (location.country || location.timezone) profileAttributes.location = location;

        var controller = typeof AbortController === 'function' ? new AbortController() : null;
        var timer = controller ? setTimeout(function () { controller.abort(); }, 8000) : null;

        fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(companyId), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          signal: controller ? controller.signal : undefined,
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: '5 Signature Re-stock',
                profile: { data: { type: 'profile', attributes: profileAttributes } }
              },
              relationships: { list: { data: { type: 'list', id: listId } } }
            }
          })
        })
          .then(function (response) {
            if (response.ok || response.status === 202) return true;
            throw new Error('Klaviyo subscribe failed with status ' + response.status);
          })
          .then(function () {
            if (timer) clearTimeout(timer);
            var ok = document.createElement('div');
            ok.className = 'v2_pdp_bis__success';
            ok.setAttribute('role', 'status');
            ok.textContent = successText;
            form.innerHTML = '';
            form.appendChild(ok);
          })
          .catch(function () {
            if (timer) clearTimeout(timer);
            setBusy(false);
            showError('Noget gik galt. Prøv igen om lidt.');
          });
      }, true);
    }

    function initBisBar() {
      document.querySelectorAll('[data-bisbar]').forEach(function (bar) {
        if (bar._bisbarReady) return;
        bar._bisbarReady = true;
        var sid = bar.getAttribute('data-section-id');
        var root = (sid && document.querySelector('pdp-design-v1[data-section-id="' + sid + '"]')) || document.querySelector('pdp-design-v1');
        var inline = root ? root.querySelector('.v2_pdp_bis') : null;
        var popup = document.querySelector('[data-bispop]' + (sid ? '[data-section-id="' + sid + '"]' : ''));

        // Reveal the bar once the inline signup has scrolled above the viewport.
        if (inline) {
          var evaluate = function () {
            // show the bar when the inline signup's bottom is above the viewport top
            bar.hidden = inline.getBoundingClientRect().bottom > 0;
          };
          window.addEventListener('scroll', evaluate, { passive: true });
          window.addEventListener('resize', evaluate, { passive: true });
          evaluate();
        }

        function unlockScroll() { document.documentElement.style.overflow = ''; document.body.style.overflow = ''; }
        function closePopup() {
          if (!popup) return;
          try { if (popup.open && typeof popup.close === 'function') popup.close(); else popup.removeAttribute('open'); }
          catch (e) { popup.removeAttribute('open'); }
          unlockScroll();
        }
        var trigger = bar.querySelector('[data-bis-open]');
        if (trigger && popup) {
          trigger.addEventListener('click', function () {
            if (popup.parentNode !== document.body) document.body.appendChild(popup);
            document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden';
            try { if (typeof popup.showModal === 'function') { if (!popup.open) popup.showModal(); } else { popup.setAttribute('open', ''); } }
            catch (e) { popup.setAttribute('open', ''); }
          });
        }
        if (popup) {
          var cb = popup.querySelector('[data-bispop-close]');
          if (cb) cb.addEventListener('click', closePopup);
          popup.addEventListener('click', function (e) { if (e.target === popup) closePopup(); });
          popup.addEventListener('cancel', closePopup);
          popup.addEventListener('close', unlockScroll);
          // The popup is a mobile-only affordance; if the viewport grows to desktop while it is
          // open (e.g. resizing the window), close it so it never lingers over the page.
          window.addEventListener('resize', function () {
            if (popup.open && window.matchMedia('(min-width: 768px)').matches) closePopup();
          }, { passive: true });
        }
      });
    }

    function bootKlaviyoForRoot(root) {
      if (!root) return;
      initCustomKlaviyoForm(root);
      initColorSelectionSubmit(root);
    }

    function bootAll() {
      document.querySelectorAll('pdp-design-v1').forEach(bootKlaviyoForRoot);
      // back-in-stock forms can live inline AND in a floating bar / popup outside the custom element
      document.querySelectorAll('[data-bis-form]').forEach(initBackInStockForm);
      initBisBar();
    }

    // The section markup already exists when this inline script runs. Bind now so
    // the form cannot fall back to a native GET navigation before DOMContentLoaded.
    bootAll();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootAll);
    }

    // Theme editor / late upgrades
    document.addEventListener('shopify:section:load', bootAll);
    window.addEventListener('pageshow', bootAll);
    setTimeout(bootAll, 0);
  })();
